import React, { useEffect } from "react";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Pediatricscon from "./Pediatricscon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Pediatrics() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Pediatricscon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Paediatric Doctor in Whitefield</title>
        <meta
          name="description"
          content="We have the best Paediatric Doctor in Whitefield and Vijayanagar. If you are looking for this then feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Paediatric Doctor in Whitefield, Best Paediatric Doctor in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestpediatricsservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestpediatricsservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers comprehensive pediatrics services including newborn and child health checkups, fever and infection care, vaccination guidance, growth & development monitoring, nutrition counseling, and pediatric follow-ups with experienced doctors.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: ["+91-9535264855", "+91-9535264854"],
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Pediatric consultation and diagnosis",
              "Newborn care and well-baby checkups",
              "Childhood fever, cold, cough and infections",
              "Growth and developmental assessment",
              "Immunization and vaccination guidance",
              "Nutrition counseling for infants and children",
              "Pediatric allergy and asthma care",
              "Pediatric follow-up and preventive care",
            ],
            keywords: [
              "best pediatrics services in Immadihalli",
              "best pediatrics services in Whitefield",
              "best pediatrics services in Bangalore",
              "best pediatrics services in Kundalahalli",
              "best pediatrics services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Best Paediatric Doctor in Whitefield happiness of your little ones is
        unwavering. Contact us today for the best Paediatric Doctor in
        Whitefield.
      </h2>

      <Servicebanner name="Pediatrics" banner={"../photo/dd17.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Pediatrics;
